import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import {
    addCommitteeMember,
    fetchCommitteesMembers,
    deleteCommitteeMember,
    fetchPositionsByPositionGroup
} from '../../../../../../Redux/Actions/Admin/ManageCommitteeMemberAction'
import { fetchMembershipPackages } from '../../../../../../Redux/Actions/EndUser/MembershipAction';
import { toastr } from '../../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import CommitteeMembers from '../CommitteeMembers/CommitteeMembers';
import { NavLink } from 'react-router-dom';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { auth } from '../../../../../../services';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';
import _ from 'lodash';
import './AddMemberForm.scss';

class AddMemberForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: true,
            membershipData: [],
            alert: { visible: false},
            memberDetails: this.props.dataItem || null,
            isLookupEnabled: false,
            emailMessage: '',
            positionMessage: '',
            memberInEdit: {
                committeeMemberId: 0,
                email: '',
                firstName: '',
                lastName: '',
                committeeName: '',
                positionName: '',
                positionGroupName: '',
                positionRanking: 0,
                positionId: 0,
                aspNetUserId: '',
                isActive: false,
                CommitteeId: this.props.dataItem.CommitteeId || null,
                begDate: null,
                endDate: null
            },
        };

        this.delayedCallback = _.debounce(this.checkEmailCall, 1000);
        this.onEmailChange = this.onEmailChange.bind(this);
    }

    componentDidMount() {
        this.props.fetchPositionsByPositionGroup(this.state.memberDetails.PositionGroupId);
        this.props.fetchCommitteesMembers(this.state.memberDetails.CommitteeId);
    }

    _export;
    export = () => {
        this._export.save();
    };

    toggleActive = (dataItem) => {
        dataItem.isActive = !dataItem.isActive;
        this.props.deleteCommitteeMember(dataItem);
    };

    handleChange = () => {
        this.setState({ toggled: !this.state.toggled });
        this.setState({
            filter: {
                logic: 'and',
                filters: [{ field: 'isActive', operator: 'eq', value: !this.state.toggled, ignoreCase: true }]
            }
        });
    }

    handleAddCommitteeMemberFunc = async (response, addCommitteeMember) => {
        if (response.data.message != "OK") {
            this.setState({
                emailMessage: response.data.message
            });
        }
        else {
            await this.props.addCommitteeMember(addCommitteeMember);
        }
    }

    handleAddSubmit = async (event) => {
        event.preventDefault();
        let t = this.state.memberInEdit;
        const options = { method: 'POST', headers: auth.authHeader() };
        
        var response = await axios.post(`${ROOT_API_URL}/ManageCommitteeMember/IsDuplicateMemberInCommittee`, this.state.memberInEdit, options);

        await this.handleAddCommitteeMemberFunc(response, this.state.memberInEdit);

        this.props.fetchCommitteesMembers(this.state.memberInEdit.CommitteeId);
    }

    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.memberInEdit;
        edited[name] = value;
        this.setState({
            memberInEdit: edited
        });

        if (name == 'email') {
            this.setState({
                emailMessage: ''
            });
        }
        else if (name == 'position') {
            this.setState({
                positionMessage: ''
            });
        }
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.cancel();
    }

    handlePositionChange = (event) => {
        let target = event.target;
        const value = target.value;
        const edited = this.state.memberInEdit;
        edited.positionId = value.positionId;
        edited.positionName = value.name;
        this.setState({
            memberInEdit: edited,
            positionMessage: ''
        });
    }
    handleBegDate = (event) => {
        const edited = this.state.memberInEdit;
        edited.begDate = event.target.value;
        this.setState({
            memberInEdit: edited
        });
    };
    handleEndDate = (event) => {
        const edited = this.state.memberInEdit;
        edited.endDate = event.target.value;
        this.setState({
            memberInEdit: edited
        });
    };

    checkboxChange = (event) => {
        let a = this.state;
        this.setState({
            isLookupEnabled: event.target.checked
        });

        let t = this.state;
        this.setState({
            toggled: true,
            membershipData: [],
            memberDetails: this.props.dataItem || null,
            membershipLookupTerm: '',
            alert: { visible: false },
            emailMessage: '',
            positionMessage: t.positionMessage ? t.positionMessage : '',
            memberInEdit: {
                committeeMemberId: 0,
                email: '',
                firstName: '',
                lastName: '',
                committeeName: '',
                positionName: t.memberInEdit.positionName ? t.memberInEdit.positionName : '',
                positionGroupName: t.memberInEdit.positionGroupName ? t.memberInEdit.positionGroupName : '',
                positionRanking: t.memberInEdit.positionRanking ? t.memberInEdit.positionRanking : 0,
                positionId: t.memberInEdit.positionId ? t.memberInEdit.positionId : 0,
                aspNetUserId: '',
                isActive: false,
                CommitteeId: this.props.dataItem.CommitteeId || null,
                begDate: new Date(),
                endDate: new Date((new Date()).getFullYear() + 1, (new Date()).getMonth(), (new Date()).getDate()),
            },
        })
        
    }

    onLookupChange = (event) => {
        var userId = '';
        if (auth.isAuthenticated()) {
            userId = auth.getAuthUserId()
        }
        this.setState(
            {
                membershipLookupTerm: event.target.value
            },
            () => {
                this.delayedCallback();
            }

        );
    };

    onEmailChange = (event) => {
        var userId = '';
        if (auth.isAuthenticated()) {
            userId = auth.getAuthUserId()
        }
        this.setState(
            {
                membershipLookupTerm: event.target.value,
                emailMessage: ''
            },
            () => {
                this.delayedCallback();
            }

        );
    };

    checkEmailCall() {
        this.setState({ isLoading: true })
        const options = { method: 'POST', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/ManageTransaction/SearchMembership?searchTerm=${this.state.membershipLookupTerm}`, options)
            .then((response) => {
                if (response.data.length > 0) {
                    this.setState({
                        membershipData: response.data, isLoading: false
                    },
                        () => this.setAlert(true, "Users Found", 'success')
                    );
                    setTimeout(() => {
                        this.setAlert(false, "");
                    }, 5000)
                } else if (response.data.length === 0) {
                    this.setState({
                        membershipLookupTerm: this.state.membershipLookupTerm,
                        membershipData: response.data,
                        isLoading: false
                    },
                        () => this.setAlert(true, "No Users Found", 'danger')
                    );
                    setTimeout(() => {
                        this.setAlert(false, "");
                    }, 5000)
                } else {
                    this.setState({
                        membershipLookupTerm: this.state.membershipLookupTerm,
                        isLoading: false
                    },
                        () => this.setAlert(true, response.data.message, 'danger')
                    );
                    setTimeout(() => {
                        this.setAlert(false, "");
                    }, 5000)
                }
            })
            .catch((response) => {
                this.setState({ isLoading: false }, () => this.setAlert(true, response.message, 'danger'))
            });
    }

    setAlert = (visible, message, color) => {
        let alert = {
            color: color,
            visible: visible,
            message: message
        }
        this.setState({
            alert: alert
        })
    }

    handleMembershipSelectChange = (event) => {
        if (event.target.value !== null) {
            this.props.fetchMembershipPackages(event.target.value.membershipType.membershipTypeID);
            let memberInEdit = { ...this.state.memberInEdit }
            memberInEdit.firstName= event.target.value.firstName;
            memberInEdit.lastName= event.target.value.lastName;
            memberInEdit.email= event.target.value.email;
            this.setState({
                memberInEdit: memberInEdit
            });
        }
    }

    render() {
        return (
            <div className="committeeForm">
                <Alert
                    color={this.state.alert.color}
                    isOpen={this.state.alert.visible}
                    style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                >
                    {this.state.alert.message}
                </Alert>
                <div className="row">
                    <div className="form-group col-md-12 col-lg-12">
                        {this.props.common.visible ? (
                            <Alert
                                color={this.props.common.color}
                                isOpen={this.props.common.visible}
                                style={{ position: 'fixed', width: '100%', maxHeight: '50px', zIndex: '1', top: '110px' }}
                            >
                                {this.props.common.message}
                            </Alert>
                        ) : null}
                        <h2>Members</h2>
                        <h3>
                            <div className="highlight">
                                Committee:
                                <span >{" "}{this.state.memberDetails.Name} ({this.state.memberDetails.Acronym})</span>
                            </div>
                        </h3>
                        <ul className="cmtee-adjst">
                            <li><b>Committee Type:</b> {this.state.memberDetails.CommitteeType.description}</li>
                            <br></br>
                            <li><b>Parent Committee:</b> {this.state.memberDetails.ParentCommitteeId ? this.state.memberDetails.ParentCommitteeName : "N/a"}</li>
                            <br></br>
                            <li><b>Position Group:</b> {this.state.memberDetails.PositionGroupId ? this.state.memberDetails.PositionGroup.description : "N/a"}</li>
                            <br></br>
                        </ul>
                    </div>
                </div>

                <form className="user-form adjst-btm1" onSubmit={this.handleAddSubmit}>
                    <div className="row">
                        <div className="form-group col-md-12 col-lg-12">
                            <h3 className="highlight adjust-add-mmbr">Add Member </h3>
                            <div className="cmtee-adjst">
                                <div className="row">
                                    <div className="col-md-12">
                                        <input
                                            style={{ width: '20px', height: '20px', margin: '0px 10px 0 0' }}
                                            name="isLookup"
                                            onChange={this.checkboxChange}
                                            type="checkbox"
                                            checked={this.state.isLookupEnabled}
                                            align="left"
                                    />
                                        <label htmlFor="isLookup" className="label-header">Search existing member</label>
                                    </div>
                                </div>
                                {this.state.isLookupEnabled ?
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label htmlFor="memberLookup" className="label-header">Membership Lookup: </label>
                                            <Input name="memberLookup"
                                                id="memberLookup"
                                                value={this.state.membershipLookupTerm}
                                                onChange={this.onLookupChange}
                                                type="text"
                                                placeholder="Please enter member ID, email, or name."
                                            />
                                        </div>
                                    </div> : ""}
                                {this.state.membershipData.length > 0 ? <div className="row">
                                    <div className="col-md-12">
                                        <label htmlFor="subscriptionId">Please Select Member</label>
                                        <DropDownList data={this.state.membershipData}
                                            textField="fullConcatinatedMembershipString"
                                            dataItemKey="membershipId"
                                            onChange={this.handleMembershipSelectChange}
                                            value={this.state.selectedMember}
                                            allowCustom={false}
                                            filterable={false}
                                            clearButton={false}
                                            required={true}
                                        />
                                    </div>
                                </div> : ""}
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="firstName">First Name</label>
                                        <Input
                                            required={true}
                                            type="text"
                                            name="firstName"
                                            id="firstName"
                                            value={this.state.memberInEdit.firstName || ''}
                                            onChange={this.onDialogInputChange}
                                            disabled={this.state.isLookupEnabled}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="lastName">Last Name</label>
                                        <Input
                                            required={true}
                                            type="text"
                                            name="lastName"
                                            id="lastName"
                                            value={this.state.memberInEdit.lastName || ''}
                                            onChange={this.onDialogInputChange}
                                            disabled={this.state.isLookupEnabled}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="email">Email</label>
                                        <Input
                                            required={true}
                                            type="text"
                                            name="email"
                                            id="email"
                                            value={this.state.memberInEdit.email || ''}
                                            onChange={this.onDialogInputChange}
                                            disabled={this.state.isLookupEnabled}
                                        />
                                        <p className="error-message">{this.state.emailMessage}</p>
                                    </div>
                                </div>
                                <section className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="position">Position</label>
                                        <DropDownList
                                            textField="name"
                                            name="position"
                                            dataItemKey="positionId"
                                            allowCustom={true}
                                            id="positionId"
                                            data={this.props.committeeMembers.positionsByGroup}
                                            onChange={this.handlePositionChange}
                                            value={this.state.memberInEdit.position}
                                            required={true}
                                        />
                                        <p className="error-message">{this.state.positionMessage}</p>
                                    </div>
                                    {/*<div className="col-md-3">
                                        <label htmlFor="positionRanking">Position Rank </label>
                                        <Input
                                            required={true}
                                            type="number"
                                            name="positionRanking"
                                            id="positionRanking"
                                            value={this.state.memberInEdit.positionRanking || ''}
                                            onChange={this.onDialogInputChange}
                                        />
                                    </div>*/}
                                    <div className="col-md-4">
                                        <label>Beginning Date</label>
                                        <DatePicker
                                            required={true}
                                            name="begDate"
                                            value={this.state.memberInEdit.begDate}
                                            onChange={this.handleBegDate}
                                            format="MM/dd/yyyy"
                                            max={this.state.memberInEdit.endDate ? this.state.memberInEdit.endDate:new Date(new Date().getFullYear() + 100, new Date().getMonth(), new Date().getDate())}
                                        />
                                    </div>
                                    {this.state.memberInEdit.begDate?
                                    <div className="col-md-4">                            
                                        <label>End Date</label>
                                        <DatePicker
                                            required={true}
                                            defaultValue={new Date()}
                                            name="endDate"
                                            value={this.state.memberInEdit.endDate}
                                            onChange={this.handleEndDate}
                                            format="MM/dd/yyyy"
                                            min={this.state.memberInEdit.begDate}
                                        />
                                    
                                        </div>
                                        : ""}
                                </section>
                            </div>
                            <button type="submit" className="admin-k-button add-mmbr-cmt add12">
                                <i className="fas fa-save"></i>
                                <span>ADD</span>
                            </button>
                        </div>
                    </div>
                </form>
                <div className="member-form form-group col-md-12 col-lg-12">
                    <CommitteeMembers committeeId={this.state.memberInEdit.CommitteeId} />
                </div>
                <div className="footer col-md-12">
                    <div className="form-group">
                        <button className="admin-k-button" onClick={this.props.cancel}>
                            <i className="fas fa-times"></i>
                            <span> CANCEL</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        common: state.common,
        committeeMembers: state.committeeMember
    };
}

export default connect(
    mapStateToProps, {
        addCommitteeMember,
        fetchCommitteesMembers,
        deleteCommitteeMember,
        fetchPositionsByPositionGroup,
        fetchMembershipPackages
})(AddMemberForm);
